import { CellTable } from "@/atoms"
import { CELLS, getDefaultColumnParams } from "@/helpers/table.helpers"
import { CellTableCustomTooltip } from "@/molecules/CellTableCustomTooltip"
import { HeaderCell } from "@/molecules/HeaderCell"
import { ImpactCell } from "@/molecules/ImpactCell"
import { KodemScore } from "@/molecules/KodemScoreCell"
import { TriageActionCell } from "@/molecules/TriageActionCell"
import { ProjectsTooltipContent } from "../../molecules/InfoHeader"
import { InsightsTriageCell } from "../../molecules/InsightsTriageCell"
import { KodemScoreHeaderCell } from "../../molecules/KodemScoreHeaderCell"
import { ResourceCell } from "../../molecules/ResourceCell"
import { renderProjectTakenActions } from "../../molecules/TakenActionsCell"

import type { SortOrder } from "@/atoms"
import type { RowClick } from "@/hooks/useLinkDrawerTooltip"
import type { NumberConvertor } from "@/hooks/useNumberConvertor"
import type { ORDER_BY_PROPS } from "@/hooks/useOrderBy"
import type { TFunction } from "@/hooks/useTranslation"

export const getColumnsTable = (props: {
  t: TFunction
  convertors: NumberConvertor
  orderByProps: Omit<ORDER_BY_PROPS, "onSorterChange">
  onRowClick: RowClick
  internetFacingFF: boolean
  isDemo?: boolean
}) => {
  const { t, onRowClick, orderByProps: sorter, internetFacingFF } = props
  const { isDemo } = props

  return [
    {
      title: HeaderCell({
        title: "Projects",
        Content: ProjectsTooltipContent(t)
      }),
      width: "100%",
      render: ResourceCell({ t, onRowClick }),
      ...getDefaultColumnParams("name", sorter, {
        customSorterName: "projectName"
      }),
      sortDirections: ["ascend", "descend", "ascend"] as SortOrder[]
    },
    {
      title: KodemScoreHeaderCell(t),
      width: 135,
      className: "center-align-tab-template-component",
      render: (score: number) =>
        CellTableCustomTooltip(t("triage.kodemScoreTooltip"))(
          KodemScore({ score })
        ),
      ...getDefaultColumnParams("kodemScore", sorter),
      defaultSortOrder: "descend" as SortOrder,
      sortDirections: ["descend", "ascend", "descend"] as SortOrder[]
    },
    {
      title: "Insights",
      width: 150,
      render: InsightsTriageCell(t, internetFacingFF, isDemo),
      ...getDefaultColumnParams("riskInsights")
    },
    CELLS.getIssuesSummaryCell(props),
    {
      title: "Apps",
      width: 70,
      className: "center-align-tab-template-component",
      render: ImpactCell({ t, onRowClick }),
      ...getDefaultColumnParams("applicationCount", sorter),
      sortDirections: ["descend", "ascend", "descend"] as SortOrder[]
    },
    {
      title: "Actions",
      width: 84,
      className: "center-align-tab-template-component",
      render: isDemo ? renderProjectTakenActions : TriageActionCell
    },
    {
      title: "Discovered",
      width: 125,
      render: CellTable,
      ...getDefaultColumnParams("discoveredDaysAgo", sorter, {
        customSorterName: "discoveredAt"
      })
    }
  ]
}
